import React from "react"

import { AttachmentType } from "shared/types/__generated__/graphql"

import { AttachmentLinkForm } from "features/attachment-links/ui/AttachmentLinkForm"

import { useFloorFormAttachmentsContext } from "../context/FloorFormAttachmentsContext"
import { useFloorFormContext } from "../contexts/FloorFormContext"

function getFormFieldName(attachment: AttachmentType) {
  return `attachments.${attachment.id}`
}

export const FloorFormAttachmentsTab = React.memo(() => {
  const { attachments, linkedAttachments, attachmentCategories, onUpload } =
    useFloorFormAttachmentsContext()

  const { isReadonly } = useFloorFormContext()

  return (
    <div className="floor-form__tab-content floor-form__tab-content--attachments">
      <AttachmentLinkForm
        attachments={attachments}
        linkedAttachments={linkedAttachments}
        getName={getFormFieldName}
        categories={attachmentCategories}
        isReadonly={isReadonly}
        onUpload={onUpload}
      />
    </div>
  )
})
